import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

const formScheme: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'weightAndWaist',
		children: [
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
			},
			{
				type: MagicField.RADIOLIST,
				key: 'toggle',
				title: 'diabetes.weightAndWaistMonitoring.label',
				settings: {
					required: true,
				},
				inLine: true,
				children: [
					{
						value: '1',
						title: 'base.yes',
					},
					{
						value: '0',
						title: 'base.no',
					},
				],
			},
			{
				settings: {
					rules: [
						{
							formControlKey: 'weightAndWaist.toggle',
							rule: 'equal',
							value: '0',
						},
					],
				},
				type: MagicField.CONDITION,
				subtype: 'view',
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'confirmation',
								title: 'component.monitoring.weightAndWaist.confirmation',
								settings: {
									required: true,
								},
								inLine: true,
								children: [
									{
										value: '1',
										title: 'component.monitoring.yes',
									},
									{
										value: '0',
										title: 'component.monitoring.no',
									},
								],
							},
						],
					},
				],
			},
			{
				settings: {
					rules: [
						{
							formControlKey: 'weightAndWaist.toggle',
							rule: 'equal',
							value: '1',
						},
					],
				},
				type: MagicField.CONDITION,
				subtype: 'view',
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								title: 'base.setTheFrequencyOfQueries',
								settings: {
									required: true,
								},
								children: [
									{
										value: 'weeklyThu5',
										title: 'component.monitoring.frequency.weeklyThu5.text',
										settings: {
											tooltip: {
												content:
													'component.monitoring.frequency.weeklyThu5.tip',
											},
										},
									},
									{
										value: 'monthlyFirstThu5',
										title:
											'component.monitoring.frequency.monthlyFirstThu5.text',
										settings: {
											tooltip: {
												content:
													'component.monitoring.frequency.monthlyFirstThu5.tip',
											},
										},
									},
									{
										value: 'custom',
										title: 'component.monitoring.frequency.custom.text',
										settings: {
											tooltip: {
												content: 'component.monitoring.frequency.custom.tip',
											},
										},
									},
								],
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'weightAndWaist.frequency',
											rule: 'equal',
											value: 'custom',
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												key: 'customSending',
												title: 'customSending',
												type: MagicField.MULTIPLIER,
												value: null,
												children: [
													{
														type: MagicField.HSTACK,
														children: [
															{
																type: MagicField.SELECT,
																key: 'customDayOfWeek',
																title: 'base.days.one',
																value: '1',
																children: [
																	{
																		key: '1',
																		title: 'component.time.monday',
																		value: '1',
																	},
																	{
																		key: '2',
																		title: 'component.time.tuesday',
																		value: '2',
																	},
																	{
																		key: '3',
																		title: 'component.time.wednesday',
																		value: '3',
																	},
																	{
																		key: '4',
																		title: 'component.time.thursday',
																		value: '4',
																	},
																	{
																		key: '5',
																		title: 'component.time.friday',
																		value: '5',
																	},
																	{
																		key: '6',
																		title: 'component.time.saturday',
																		value: '6',
																	},
																	{
																		key: '7',
																		title: 'component.time.sunday',
																		value: '7',
																	},
																],
																settings: {
																	required: true,
																},
															},
															{
																type: MagicField.TIMEPICKER,
																key: 'customTime',
																title: 'base.shared.time',
																settings: {
																	minuteStep: 5,
																	required: true,
																},
															},
														],
													},
													{
														type: MagicField.MULTIPLIER_REMOVE_BUTTON,
													},
												],
												settings: {
													createDefault: 1,
													addButtonTitle: 'base.addDay',
												},
											},
										],
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'hearthBeatAndPressure',
		children: [
			{
				type: MagicField.TEXT_FIELD,
				key: 'diabetesHeartbeatAndPressure',
				settings: {
					hidden: true,
				},
			},
			{
				type: MagicField.RADIOLIST,
				key: 'toggle',
				title: 'diabetes.hearthBeatAndPressureMonitoring.label',
				settings: {
					required: true,
				},
				inLine: true,
				children: [
					{
						value: '1',
						title: 'base.yes',
					},
					{
						value: '0',
						title: 'base.no',
					},
				],
			},
			{
				settings: {
					rules: [
						{
							formControlKey: 'hearthBeatAndPressure.toggle',
							rule: 'equal',
							value: '0',
						},
					],
				},
				type: MagicField.CONDITION,
				subtype: 'view',
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'confirmation',
								title:
									'component.monitoring.hearthBeatAndPressure.confirmation',
								settings: {
									required: true,
								},
								inLine: true,
								children: [
									{
										value: '1',
										title: 'component.monitoring.yes',
									},
									{
										value: '0',
										title: 'component.monitoring.no',
									},
								],
							},
						],
					},
				],
			},
			{
				settings: {
					rules: [
						{
							formControlKey: 'hearthBeatAndPressure.toggle',
							rule: 'equal',
							value: '1',
						},
					],
				},
				type: MagicField.CONDITION,
				subtype: 'view',
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								title: 'base.setTheFrequencyOfQueries',
								settings: {
									required: true,
								},
								children: [
									{
										value: 'weeklyWed7',
										title: 'component.monitoring.frequency.weeklyWed7.text',
										settings: {
											tooltip: {
												content:
													'component.monitoring.frequency.weeklyWed7.tip',
											},
										},
									},
									{
										value: 'monthlyFirstWed7',
										title:
											'component.monitoring.frequency.monthlyFirstWed7.text',
										settings: {
											tooltip: {
												content:
													'component.monitoring.frequency.monthlyFirstWed7.tip',
											},
										},
									},
									{
										value: 'weeklyMon7Thu20',
										title:
											'component.monitoring.frequency.weeklyMon7Thu20.text',
										settings: {
											tooltip: {
												content:
													'component.monitoring.frequency.weeklyMon7Thu20.tip',
											},
										},
									},
									{
										value: 'daily81721',
										title: 'component.monitoring.frequency.daily81721.text',
										settings: {
											tooltip: {
												content:
													'component.monitoring.frequency.daily81721.tip',
											},
										},
									},
									{
										value: 'custom',
										title: 'component.monitoring.frequency.custom.text',
										settings: {
											tooltip: {
												content: 'component.monitoring.frequency.custom.tip',
											},
										},
									},
								],
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'hearthBeatAndPressure.frequency',
											rule: 'equal',
											value: 'custom',
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												key: 'customSending',
												title: 'customSending',
												type: MagicField.MULTIPLIER,
												value: null,
												settings: {
													createDefault: 1,
													addButtonTitle: 'base.addDay',
												},
												children: [
													{
														type: MagicField.HSTACK,
														children: [
															{
																type: MagicField.SELECT,
																key: 'customDayOfWeek',
																title: 'base.days.one',
																value: '1',
																children: [
																	{
																		key: '1',
																		title: 'component.time.monday',
																		value: '1',
																	},
																	{
																		key: '2',
																		title: 'component.time.tuesday',
																		value: '2',
																	},
																	{
																		key: '3',
																		title: 'component.time.wednesday',
																		value: '3',
																	},
																	{
																		key: '4',
																		title: 'component.time.thursday',
																		value: '4',
																	},
																	{
																		key: '5',
																		title: 'component.time.friday',
																		value: '5',
																	},
																	{
																		key: '6',
																		title: 'component.time.saturday',
																		value: '6',
																	},
																	{
																		key: '7',
																		title: 'component.time.sunday',
																		value: '7',
																	},
																],
																settings: {
																	required: true,
																},
															},
															{
																type: MagicField.TIMEPICKER,
																key: 'customTime',
																title: 'base.shared.time',
																settings: {
																	minuteStep: 5,
																	required: true,
																},
															},
														],
													},
													{
														type: MagicField.MULTIPLIER_REMOVE_BUTTON,
													},
												],
											},
										],
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.RADIOLIST,
		key: 'toggleGlycemiaMonitoring',
		title: 'diabetes.glycemiaMonitoring.label',
		settings: {
			required: true,
		},
		inLine: true,
		children: [
			{
				value: '1',
				title: 'base.yes',
			},
			{
				value: '0',
				title: 'base.no',
			},
		],
	},
	{
		settings: {
			rules: [
				{
					formControlKey: 'toggleGlycemiaMonitoring',
					rule: 'equal',
					value: '0',
				},
			],
		},
		type: MagicField.CONDITION,
		subtype: 'view',
		children: [
			{
				type: MagicField.CONTAINER,
				settings: {
					showLine: true,
				},
				children: [
					{
						type: MagicField.RADIOLIST,
						key: 'confirmationMonitoringOff',
						title: 'component.monitoring.monitoringOff.confirmation',
						settings: {
							required: true,
						},
						inLine: true,
						children: [
							{
								value: '1',
								title: 'component.monitoring.yes',
							},
							{
								value: '0',
								title: 'component.monitoring.no',
							},
						],
					},
				],
			},
		],
	},
	{
		settings: {
			rules: [
				{
					formControlKey: 'toggleGlycemiaMonitoring',
					rule: 'equal',
					value: '1',
				},
			],
		},
		type: MagicField.CONDITION,
		subtype: 'view',
		children: [
			{
				type: MagicField.CONTAINER,
				settings: {
					showLine: true,
				},
				children: [
					{
						type: MagicField.TEXT,
						title: 'component.monitoring.subtitle',
						subType: 'header',
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemiaFasting',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemiaFasting',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title: 'component.monitoring.questionary.glycemiaFasting',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemiaFasting.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily5',
														title: 'component.monitoring.frequency.daily5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily5.tip',
															},
														},
													},
													{
														value: 'weeklyWed5',
														title:
															'component.monitoring.frequency.weeklyWed5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed5.tip',
															},
														},
													},
													{
														value: 'weeklyWed5Sat5',
														title:
															'component.monitoring.frequency.weeklyWed5Sat5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed5Sat5.tip',
															},
														},
													},
													{
														value: 'weeklyMon5Tue5Wed5Sat5',
														title:
															'component.monitoring.frequency.weeklyMon5Tue5Wed5Sat5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon5Tue5Wed5Sat5.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey: 'glycemiaFasting.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemiaBeforeBreakfast',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemiaBeforeBreakfast',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title:
									'component.monitoring.questionary.glycemiaBeforeBreakfast',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemiaBeforeBreakfast.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily5',
														title: 'component.monitoring.frequency.daily5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily5.tip',
															},
														},
													},
													{
														value: 'weeklyWed5',
														title:
															'component.monitoring.frequency.weeklyWed5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed5.tip',
															},
														},
													},
													{
														value: 'weeklyWed5Sat5',
														title:
															'component.monitoring.frequency.weeklyWed5Sat5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed5Sat5.tip',
															},
														},
													},
													{
														value: 'weeklyMon5Tue5Wed5Sat5',
														title:
															'component.monitoring.frequency.weeklyMon5Tue5Wed5Sat5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon5Tue5Wed5Sat5.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey:
																'glycemiaBeforeBreakfast.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemiaBeforeLunch',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemiaBeforeLunch',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title: 'component.monitoring.questionary.glycemiaBeforeLunch',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemiaBeforeLunch.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily11',
														title:
															'component.monitoring.frequency.daily11.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily11.tip',
															},
														},
													},
													{
														value: 'weeklyWed11',
														title:
															'component.monitoring.frequency.weeklyWed11.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed11.tip',
															},
														},
													},
													{
														value: 'weeklyWed11Sat11',
														title:
															'component.monitoring.frequency.weeklyWed11Sat11.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed11Sat11.tip',
															},
														},
													},
													{
														value: 'weeklyMon11Tue11Wed11Sat11',
														title:
															'component.monitoring.frequency.weeklyMon11Tue11Wed11Sat11.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon11Tue11Wed11Sat11.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey: 'glycemiaBeforeLunch.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemiaBeforeDinner',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemiaBeforeDinner',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title: 'component.monitoring.questionary.glycemiaBeforeDinner',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemiaBeforeDinner.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily17',
														title:
															'component.monitoring.frequency.daily17.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily17.tip',
															},
														},
													},
													{
														value: 'weeklyWed17',
														title:
															'component.monitoring.frequency.weeklyWed17.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed17.tip',
															},
														},
													},
													{
														value: 'weeklyWed17Sat17',
														title:
															'component.monitoring.frequency.weeklyWed17Sat17.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed17Sat17.tip',
															},
														},
													},
													{
														value: 'weeklyMon17Tue17Wed17Sat17',
														title:
															'component.monitoring.frequency.weeklyMon17Tue17Wed17Sat17.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon17Tue17Wed17Sat17.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey: 'glycemiaBeforeDinner.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemia2HoursAfterBreakfast',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemia2HoursAfterBreakfast',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title:
									'component.monitoring.questionary.glycemia2HoursAfterBreakfast',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemia2HoursAfterBreakfast.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily5',
														title: 'component.monitoring.frequency.daily5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily5.tip',
															},
														},
													},
													{
														value: 'weeklyWed5',
														title:
															'component.monitoring.frequency.weeklyWed5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed5.tip',
															},
														},
													},
													{
														value: 'weeklyWed5Sat5',
														title:
															'component.monitoring.frequency.weeklyWed5Sat5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed5Sat5.tip',
															},
														},
													},
													{
														value: 'weeklyMon5Tue5Wed5Sat5',
														title:
															'component.monitoring.frequency.weeklyMon5Tue5Wed5Sat5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon5Tue5Wed5Sat5.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey:
																'glycemia2HoursAfterBreakfast.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemia2HoursAfterLunch',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemia2HoursAfterLunch',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title:
									'component.monitoring.questionary.glycemia2HoursAfterLunch',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemia2HoursAfterLunch.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily11',
														title:
															'component.monitoring.frequency.daily11.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily11.tip',
															},
														},
													},
													{
														value: 'weeklyWed11',
														title:
															'component.monitoring.frequency.weeklyWed11.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed11.tip',
															},
														},
													},
													{
														value: 'weeklyWed11Sat11',
														title:
															'component.monitoring.frequency.weeklyWed11Sat11.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed11Sat11.tip',
															},
														},
													},
													{
														value: 'weeklyMon11Tue11Wed11Sat11',
														title:
															'component.monitoring.frequency.weeklyMon11Tue11Wed11Sat11.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon11Tue11Wed11Sat11.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey:
																'glycemia2HoursAfterLunch.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemia2HoursAfterDinner',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemia2HoursAfterDinner',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title:
									'component.monitoring.questionary.glycemia2HoursAfterDinner',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemia2HoursAfterDinner.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily17',
														title:
															'component.monitoring.frequency.daily17.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily17.tip',
															},
														},
													},
													{
														value: 'weeklyWed17',
														title:
															'component.monitoring.frequency.weeklyWed17.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed17.tip',
															},
														},
													},
													{
														value: 'weeklyWed17Sat17',
														title:
															'component.monitoring.frequency.weeklyWed17Sat17.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed17Sat17.tip',
															},
														},
													},
													{
														value: 'weeklyMon17Tue17Wed17Sat17',
														title:
															'component.monitoring.frequency.weeklyMon17Tue17Wed17Sat17.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon17Tue17Wed17Sat17.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey:
																'glycemia2HoursAfterDinner.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemiaBeforeSleep',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemiaBeforeSleep',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title: 'component.monitoring.questionary.glycemiaBeforeSleep',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemiaBeforeSleep.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily20',
														title:
															'component.monitoring.frequency.daily20.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily20.tip',
															},
														},
													},
													{
														value: 'weeklyWed20',
														title:
															'component.monitoring.frequency.weeklyWed20.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed20.tip',
															},
														},
													},
													{
														value: 'weeklyWed20Sat20',
														title:
															'component.monitoring.frequency.weeklyWed20Sat20.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed20Sat20.tip',
															},
														},
													},
													{
														value: 'weeklyMon20Tue20Wed20Sat20',
														title:
															'component.monitoring.frequency.weeklyMon20Tue20Wed20Sat20.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon20Tue20Wed20Sat20.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey: 'glycemiaBeforeSleep.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemiaBeforeWorkout',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemiaBeforeWorkout',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title: 'component.monitoring.questionary.glycemiaBeforeWorkout',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemiaBeforeWorkout.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily5',
														title: 'component.monitoring.frequency.daily5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily5.tip',
															},
														},
													},
													{
														value: 'weeklyWed5',
														title:
															'component.monitoring.frequency.weeklyWed5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed5.tip',
															},
														},
													},
													{
														value: 'weeklyWed5Sat5',
														title:
															'component.monitoring.frequency.weeklyWed5Sat5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed5Sat5.tip',
															},
														},
													},
													{
														value: 'weeklyMon5Tue5Wed5Sat5',
														title:
															'component.monitoring.frequency.weeklyMon5Tue5Wed5Sat5.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon5Tue5Wed5Sat5.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey: 'glycemiaBeforeWorkout.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
					{
						type: MagicField.CONTAINER,
						key: 'glycemiaAt3Am',
						children: [
							{
								type: MagicField.TEXT_FIELD,
								key: 'glycemiaAt3Am',
								settings: {
									hidden: true,
								},
							},
							{
								type: MagicField.CHECKBOX,
								key: 'toggle',
								title: 'component.monitoring.questionary.glycemiaAt3Am',
							},
							{
								settings: {
									rules: [
										{
											formControlKey: 'glycemiaAt3Am.toggle',
											rule: 'equal',
											value: true,
										},
									],
								},
								type: MagicField.CONDITION,
								subtype: 'view',
								children: [
									{
										type: MagicField.CONTAINER,
										settings: {
											showLine: true,
										},
										children: [
											{
												type: MagicField.RADIOLIST,
												key: 'frequency',
												title: 'base.setTheFrequencyOfQueries',
												settings: {
													required: true,
												},
												children: [
													{
														value: 'daily20',
														title:
															'component.monitoring.frequency.daily20.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.daily20.tip',
															},
														},
													},
													{
														value: 'weeklyWed20',
														title:
															'component.monitoring.frequency.weeklyWed20.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed20.tip',
															},
														},
													},
													{
														value: 'weeklyWed20Sat20',
														title:
															'component.monitoring.frequency.weeklyWed20Sat20.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyWed20Sat20.tip',
															},
														},
													},
													{
														value: 'weeklyMon20Tue20Wed20Sat20',
														title:
															'component.monitoring.frequency.weeklyMon20Tue20Wed20Sat20.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.weeklyMon20Tue20Wed20Sat20.tip',
															},
														},
													},
													{
														value: 'custom',
														title: 'component.monitoring.frequency.custom.text',
														settings: {
															tooltip: {
																content:
																	'component.monitoring.frequency.custom.tip',
															},
														},
													},
												],
											},
											{
												settings: {
													rules: [
														{
															formControlKey: 'glycemiaAt3Am.frequency',
															rule: 'equal',
															value: 'custom',
														},
													],
												},
												type: MagicField.CONDITION,
												subtype: 'view',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																key: 'customSending',
																title: 'customSending',
																type: MagicField.MULTIPLIER,
																value: null,
																settings: {
																	createDefault: 1,
																	addButtonTitle: 'base.addDay',
																},
																children: [
																	{
																		type: MagicField.HSTACK,
																		children: [
																			{
																				type: MagicField.SELECT,
																				key: 'customDayOfWeek',
																				title: 'base.days.one',
																				value: '1',
																				children: [
																					{
																						key: '1',
																						title: 'component.time.monday',
																						value: '1',
																					},
																					{
																						key: '2',
																						title: 'component.time.tuesday',
																						value: '2',
																					},
																					{
																						key: '3',
																						title: 'component.time.wednesday',
																						value: '3',
																					},
																					{
																						key: '4',
																						title: 'component.time.thursday',
																						value: '4',
																					},
																					{
																						key: '5',
																						title: 'component.time.friday',
																						value: '5',
																					},
																					{
																						key: '6',
																						title: 'component.time.saturday',
																						value: '6',
																					},
																					{
																						key: '7',
																						title: 'component.time.sunday',
																						value: '7',
																					},
																				],
																				settings: {
																					required: true,
																				},
																			},
																			{
																				type: MagicField.TIMEPICKER,
																				key: 'customTime',
																				title: 'base.shared.time',
																				settings: {
																					minuteStep: 5,
																					required: true,
																				},
																			},
																		],
																	},
																	{
																		type: MagicField.MULTIPLIER_REMOVE_BUTTON,
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
				],
			},
		],
	},
];

export default formScheme;
